import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RootMaterialModule } from '../shared/modules/root-material.module';
import { LayoutModule } from '@angular/cdk/layout';
import { UserDataService } from '../shared/services/user-data.service';
import { RouterModule } from '@angular/router';

const routes = [{ path: 'login', component: LoginComponent }];

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    RootMaterialModule,
    LayoutModule,
    RouterModule.forChild(routes),
  ],
  exports: [LoginComponent],
  providers: [UserDataService],
})
export class LoginModule {}
